import { DUE_DATE_MESSAGES } from '../constants/data.constants';

/* -------------------------------------------------------------------------- */
/*                         Get overdue days from date                         */
/* -------------------------------------------------------------------------- */
export function getOverdueDaysUsingDate(selectedDate: Date): string {
  const today = new Date();
  // Reset time part for accurate date comparison
  today.setHours(0, 0, 0, 0);

  // Check if selectedDate is a valid date
  if (isNaN(selectedDate.getTime())) {
    return formatDateWithTime(today); // Return today's date in specified format if invalid
  }

  const selectedDateNew = new Date(selectedDate);
  selectedDateNew.setHours(0, 0, 0, 0);

  const timeDiff = selectedDateNew.getTime() - today.getTime();
  const diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

  if (diffDays === 0) {
    return formatDateWithTime(selectedDate);
  } else if (diffDays === -1) {
    return `1 ${DUE_DATE_MESSAGES.DAYS_OVERDUE}`;
  } else if (diffDays < -1) {
    return `${Math.abs(diffDays)} ${DUE_DATE_MESSAGES.DAYS_OVERDUE}`;
  } else {
    return formatDateWithTime(selectedDate);
  }
}

function formatDateWithTime(date: Date): string {
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };
  return new Intl.DateTimeFormat('en-US', options).format(date);
}
